import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { ChartEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useCustomerService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const CustomerRatingChart: React.FC = () => {
  const customerService = useCustomerService();
  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Pie}
      chartAPIKey={GraphConstants.ChartKeys.CustomerRatingSummary}
      chartTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Rating)}
      doughnutChartColorPalette={ChartEnums.DoughnutChartColorPalette.RATING}
      doughnutChartLegendType={ChartEnums.LegendType.LARGE}
      filterToAPIHandler={customerService.reportToAPIFilter}
      showDoughnutChartMiddleText
      usePageFilter={false}
      useClickableChart
      dataUnit={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Pc)}
      onDataPointClickedSetFilter={(label?: any) => {
        const text = typeof label === "string" ? label : undefined;
        if (!text) return {};

        switch (text.toLowerCase()) {
          case LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.Rating_Bad).toLowerCase():
            return { rating: { lowest: 0, highest: 40 } };
          case LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.Rating_Average).toLowerCase():
            return { rating: { lowest: 41, highest: 80 } };
          case LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.Rating_Good).toLowerCase():
            return { rating: { lowest: 81, highest: 100 } };
          default:
            return {};
        }
      }}
      onBackgroundClickedSetFilter={{ rating: undefined }}
    />
  );
};

export default CustomerRatingChart;
